import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=f8a12512&scoped=true&lang=pug"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"
import style0 from "./Noticias.styl?vue&type=style&index=0&id=f8a12512&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a12512",
  null
  
)

export default component.exports